import { Card } from "@mui/material";
import DataTable, { createTheme } from "react-data-table-component";

const TransactionTable = ({ transactions, columns }) => {
  createTheme(
    "solarized",
    {
      text: {
        primary: "rgb(250 204 21)",
        secondary: "rgb(250 204 21)",
      },
      background: {
        default: "#060e15",
      },
      context: {
        background: "#060e15",
        text: "#FFFFFF",
      },
      divider: {
        default: "rgb(250 204 21)",
      },
      action: {
        button: "rgba(0,0,0,.54)",
        hover: "rgba(0,0,0,.08)",
        disabled: "rgba(0,0,0,.12)",
      },
    },
    "dark"
  );
  return (
    <Card>
      <DataTable
        columns={columns}
        data={transactions}
        theme="solarized"
        pagination
      />
    </Card>
  );
};

export default TransactionTable;
